import { format } from 'date-fns'
import { GetterTree } from 'vuex'
import CONSTANTS from '@/constants'
import { isBusinessPlan } from '@/helpers'
import {
  ISubscriptionsState,
  IRootState,
  ISubscription,
  IPass,
  IUsersSubscriptions,
} from '@/@types'

const getters: GetterTree<ISubscriptionsState, IRootState> = {
  currentPasses: (_, subscriptionsGetters) => {
    const {
      usersSubscriptions: { activePlans },
    } = subscriptionsGetters
    const ownedPasses: Array<IPass> = []
    if (activePlans && activePlans.length) {
      activePlans.map((sub: ISubscription) => {
        const {
          passes: { data: passes },
        }: { passes: { data: Array<IPass> } } = sub
        passes.map(pass => ownedPasses.push(pass))
      })
    }
    return ownedPasses
  },

  usersSubscriptions: state => {
    const {
      manageablePassStates,
      currentSubscriptions,
      premiumPlanCode,
    } = state
    if (currentSubscriptions && currentSubscriptions.length) {
      return currentSubscriptions.reduce(
        (acc: IUsersSubscriptions, sub: ISubscription) => {
          const { state: status, plan_code } = sub
          if (manageablePassStates.includes(status)) {
            acc.activePlans.push(sub)
          }
          if (!isBusinessPlan(sub) && manageablePassStates.includes(status)) {
            acc.personalPlans.push(sub)
          }
          if (status === CONSTANTS.SUBSCRIPTIONS.FAILED_STATE) {
            acc.failedPlans.push(sub)
          }
          if (
            status !== CONSTANTS.SUBSCRIPTIONS.FAILED_STATE &&
            !manageablePassStates.includes(status)
          ) {
            acc.inactivePlans.push(sub)
          }
          if (CONSTANTS.PLANS.PREMIUM_PLANS.includes(plan_code)) {
            acc.premiumPlans.push(sub)
          }
          return acc
        },
        {
          personalPlans: [],
          activePlans: [],
          failedPlans: [],
          inactivePlans: [],
          premiumPlans: [],
        }
      )
    }
    return {
      personalPlans: [],
      activePlans: [],
      failedPlans: [],
      inactivePlans: [],
      migratedPlans: [],
      premiumPlans: [],
    }
  },

  isWorkbooksIncluded: (state, subscriptionsGetters) => {
    // #TODO: Content API should be determining this
    const allowed = [
      CONSTANTS.PLANS.LEGACY_ALL_ACCESS_PASS,
      ...CONSTANTS.PLANS.PREMIUM_PLANS,
      ...CONSTANTS.PLANS.BUSINESS,
      'ine_b2b_legacy',
    ]
    const hasLegacyAccess = subscriptionsGetters.currentPasses.find(
      (pass: IPass) => pass.name === 'Networking'
    )
    const hasAccess = subscriptionsGetters.usersSubscriptions.activePlans.find(
      (sub: ISubscription) => allowed.includes(sub.plan_code)
    )
    return !!hasLegacyAccess || !!hasAccess
  },

  currentPlanComparisonBreakdown: state => {
    if (state.currentPlanComparison && state.currentPlanComparison.next) {
      const { next, meta } = state.currentPlanComparison
      if (next) {
        return {
          newPrice: next.price,
          dueToday: next.due_today,
          discountCents: next.discount,
          creditForRenewal: next.credit_fwd,
          renewalTotal: next.renewal_total,
          renewalDate: format(new Date(next.period_end), 'MMMM dd, yyyy'),
          offerId: meta?.offer_id ?? '',
        }
      }
    }
    return {
      newPrice: '$0',
      dueToday: '$0',
      discountCents: '$0',
      creditForRenewal: '$0',
      renewalTotal: '$0',
      renewalDate: '',
      offerId: '',
    }
  },

  canViewBillingInfo: (subState, subGetters, rootState, rootGetters) => {
    const isStarterPassUser = rootGetters['auth/isFreeTrialUser']
    if (isStarterPassUser) {
      return false
    }
    return (
      subGetters.usersSubscriptions.personalPlans.length > 0 ||
      subGetters.usersSubscriptions.failedPlans.length > 0
    )
  },

  showAddYearBanner: state => {
    return (
      state.promotionsAvailable &&
      Object.keys(state.promotionsAvailable).length > 0
    )
  },

  activePlan: (subState, subGetters, rootState, rootGetters) => {
    const {
      usersSubscriptions: { activePlans },
    } = subGetters
    return activePlans.find(
      (p: { id: string }) =>
        p.id === subState.promotionsAvailable?.subscription_id
    )
  },
  isADUser: (state, subscriptionsGetters) => {
    const activePlans = subscriptionsGetters.usersSubscriptions?.activePlans
    if (activePlans?.length) {
      const hasADSubscription = activePlans.some(
        (subscription: { plan_code: string }) =>
          subscription.plan_code === CONSTANTS.PLANS.ATTACK_DEFENSE
      )
      return hasADSubscription
    }
    return false
  },
}

export default getters
